import apiCaller from "../../../helper/apiCall";
import { SAP_ENDPOINTS } from "../../urls/endpoints";

const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0);

/** Drops empty filter values; the server rejects "" and []. */
const buildBody = (params = {}) => {
  const body = {};
  Object.entries(params).forEach(([key, value]) => {
    if (key === "export" || isEmpty(value)) return;
    body[key] = value;
  });
  return body;
};

const post = (url, params) => apiCaller(url, "POST", buildBody(params));

/** Dropdown options: plants, document types, suppliers, code lists. */
export const fetchPoFilters = async ({ fromDate, toDate, unionId } = {}) =>
  post(SAP_ENDPOINTS.PO_FILTERS, { fromDate, toDate, unionId });

/** Cards, splits by procurement / plant type / union, and freshness. */
export const fetchPoSummary = async (filters = {}) =>
  post(SAP_ENDPOINTS.PO_SUMMARY, filters);

/** Paged PO list. */
export const fetchPoTable = async ({ search, pageNo, itemsPerPage, sort, ...filters } = {}) =>
  post(SAP_ENDPOINTS.PO_TABLE, {
    ...filters,
    search,
    pageNo: pageNo || 1,
    itemsPerPage: itemsPerPage || 20,
    sort,
  });

/** One PO: header, items, GRNs. Always send the row's plant. */
export const fetchPoView = async ({ purchaseOrder, plant } = {}) =>
  post(SAP_ENDPOINTS.PO_VIEW, { purchaseOrder, plant });

export const fetchPoTrend = async ({ granularity, ...filters } = {}) =>
  post(SAP_ENDPOINTS.PO_TREND, { ...filters, granularity });

export const fetchPoBreakdown = async ({ groupBy, topN, ...filters } = {}) =>
  post(SAP_ENDPOINTS.PO_BREAKDOWN, { ...filters, groupBy, topN });

/** XLSX of the PO table; the returned url expires after 5 minutes. */
export const exportPoTable = async ({ search, sort, ...filters } = {}) =>
  post(SAP_ENDPOINTS.PO_EXPORT, { ...filters, search, sort });

export const fetchMaterials = async ({ pageNo, itemsPerPage, ...params } = {}) =>
  post(SAP_ENDPOINTS.MATERIALS, {
    ...params,
    pageNo: pageNo || 1,
    itemsPerPage: itemsPerPage || 20,
  });

export const exportMaterials = async (params = {}) =>
  post(SAP_ENDPOINTS.MATERIALS_EXPORT, params);

/** kind: COMPANY | PURCHASING_ORG | PURCHASING_GROUP | MATERIAL_TYPE | MATERIAL_GROUP */
export const fetchCodes = async (kind) => post(SAP_ENDPOINTS.CODES, { kind });

export const fetchOrg = async ({ plantType, companyCode, includeInactive } = {}) =>
  post(SAP_ENDPOINTS.ORG, { plantType, companyCode, includeInactive });

/** Admin, or EDIT right. Both dates or neither; */
export const startPoSync = async ({ fromDate, toDate, plants } = {}) =>
  post(SAP_ENDPOINTS.PO_SYNC, { fromDate, toDate, plants });

export const startMasterSync = async ({ materialLimit } = {}) =>
  post(SAP_ENDPOINTS.MASTER_SYNC, { materialLimit });

/** Admin / Dept Admin only. */
export const fetchSyncLog = async ({ runId, feed, status, pageNo, itemsPerPage } = {}) =>
  post(SAP_ENDPOINTS.SYNC_LOG, {
    runId,
    feed,
    status,
    pageNo: pageNo || 1,
    itemsPerPage: itemsPerPage || 20,
  });
